import { render, staticRenderFns } from "./VerifyPage.vue?vue&type=template&id=f8f49072&scoped=true&"
import script from "./VerifyPage.vue?vue&type=script&lang=js&"
export * from "./VerifyPage.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPage.vue?vue&type=style&index=0&id=f8f49072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f49072",
  null
  
)

export default component.exports